import { Injectable } from '@angular/core';
import { ProjectData } from '../entities/project-data.entity';
import { ConfigService } from 'src/app/app.config';
import { Utils } from '../utils.module';

/*
	Servicio creado para la manipulación de la miniatura del proyecto utilizada
	en el listado de proyectos pero llamada de otros partes del sitio.

	Para optimizar la carga del listado la propiedad 'mini' contien información
	necesaria según tipo de proyecto:

	# Satelite, guarda la imagen (miniatura) devuelta por googleMaps, no llegan a
	pesar más de 100k. De esta forma solo hay que volcar la informacion en un
	elemento (HTML) 'img'.

	projectData.mini: {
		src: 'data:image/png;base64,...' // Data Url.
	}

	# Esquema, guarda el 'viewBox' útil para que reeescale la imagen y el 'path'
	que contiene todos los puntos que componen los los perímetros. De esta forma
	se vuelca sobre el 'SVG' estos datos para crear la miniatura.

	projectData.mini: {
			'viewBox': 0, 0, 120, 90`,
			'path': path.join('M 23 3 L 44 65 ...')
		};
	}
*/
@Injectable({
	providedIn: 'root'
})
export class MinisService {

	// URL de la api de google para hacer las peticiones de miníaturas sastélite.
	private static urlMini = 'http://maps.googleapis.com/maps/api/staticmap?maptype=hybrid&size=192x120&key=' + ConfigService.GOOGLE_API_KEY;

	// Imagenes por defecto para las miniaturas.
	public static MINI_SCHEME2 = "/assets/img/esquemaMini.jpg";
	public static MINI_SATELITE = "/assets/img/sateliteMini.jpg";

	public static COORDINATES = "coordinates";

	constructor() { }

	// Llamado por builder.service.saveProject(project: ProjectData).
	// NO GRABA SOLO PROCESA EL PROYECTO A NIVEL 'mini'.
	// 1.- Comprobar si tiene 'mini' en caso negativo crearlo nuevo END.
	public updateMini(project: ProjectData) {
		if (!project) return;

		// Comprobaciones comunes.
		// ¿existe mini?
		// ¿tiene perímetros?
		// ¿hay cambios?

		if (project.renderer === Utils.SATELITE) {

		}
		else {

		}
	}

	// Javascript genera números con muchos decimales.
	private numOk(value: number): number { return parseFloat(value.toFixed(3)); }

	public cacheCoordinates(project: ProjectData) {
		let coor = [];
		project.perimetro.forEach(p => {
			p.coordenadas.forEach(c => {
				if (!c.dots) { coor.push({ lat: c.lat, lng: c.lng }); }
				else { coor.push({ lat: c.dots[0].lat, lng: c.dots[0].lng }); }
			});
		});
		localStorage.setItem(MinisService.COORDINATES, JSON.stringify(coor));
	}

	// #################################################################
	// Es llamado para que sobreescriba el parámetro 'mini' de Esquema.
	public saveMiniEsquema(project: ProjectData) {
		//let viewBox = [0, 0, 0, 0]; // lng- (x), lat-(y), lng+(1), lat+(y1)
		let X1 = 0;
		let X2 = 0;
		let Y1 = 0;
		let Y2 = 0;
		let path = [];
		let auxLat = 0;
		let auxLng = 0;
		project.perimetro.forEach((pr) => {
			for (let i = 0; i < pr.coordenadas.length; i++) {
				if (i == 0) path.push('M'); else path.push('L');

				auxLng = this.numOk(pr.coordenadas[i].lng * 100);
				auxLat = (this.numOk(pr.coordenadas[i].lat * 100)) * -1;

				path.push(auxLng);
				path.push(auxLat);

				if (i == 0 && X1 == 0) { X1 = auxLng; X2 = auxLng; }
				else if (auxLng < X1) X1 = auxLng;
				else if (auxLng > X2) X2 = auxLng;

				if (i == 0 && Y1 == 1) { Y1 = auxLat; Y2 = auxLat; }
				else if (auxLat < Y1) Y1 = auxLat;
				else if (auxLat > Y2) Y2 = auxLat;
			}
		});

		// Quitar negativos.
		if (X1 < 0) {
			const suma = this.numOk(X1 * -1);
			X1 = 0;
			X2 = this.numOk(X2 + suma);
			for (let i = 1; i < path.length; i += 3) path[i] = this.numOk(path[i] + suma);
		}

		if (Y1 < 0) {
			const suma = this.numOk(Y1 * -1);
			Y1 = 0;
			Y2 = this.numOk(Y2 + suma);
			for (let i = 2; i < path.length; i += 3) path[i] = this.numOk(path[i] + suma);
		}

		// Alinear a cero.
		if (X1 > 0) {
			const resta = X1;
			X1 = 0;
			X2 = this.numOk(X2 - resta);
			for (let i = 1; i < path.length; i += 3) path[i] = this.numOk(path[i] - resta);
		}

		if (Y1 > 0) {
			const resta = Y1;
			Y1 = 0;
			Y2 = this.numOk(Y2 - resta);
			for (let i = 2; i < path.length; i += 3) path[i] = this.numOk(path[i] - resta);
		}

		//for (let i = 1; i < path.length; i += 3) {
		//path[i] = this.numOk(path[i] + 2);path[i + 1] = this.numOk(path[i + 1] + 2);}

		//X1 = this.numOk(X1 - 1);
		//Y1 = this.numOk(Y1 - 1);
		//X2 = this.numOk(X2 + 1);
		//Y2 = this.numOk(Y2 + 1);
		// Actualizar

		for (let i = 2; i < path.length; i += 3) path[i] = this.numOk(Y2 - path[i]);

		project.mini = {
			'viewBox': `${X1},${Y1},${X2},${Y2}`,
			'path': path.join(' ')
		};

	}

	// #################################################################
	// Es llamado para que sobreescriba el parámetro 'mini' de Satélite.
	public saveMiniSatelite(project: ProjectData, img: string): string {
		let url = MinisService.MINI_SATELITE;

		// No tiene el objeto 'project' ni la propiedad 'project.perimetro'
		if (!project || !project.perimetro) return "Objeto ProjectData corrupto.";

		// Comprobar si es del mismo tipo.
		if (project.renderer !== Utils.SATELITE) return `El proyecto '${project.nombre}' no es de tipo Satélite.`;

		// Imagen por defecto.
		project.mini = { src: MinisService.MINI_SATELITE };

		// No tiene perímetros.
		if (project.perimetro.length < 2) return `El proyecto '${project.nombre}' no tiene perímetros.`;

		// Recorre todos los perímetros para obtener sus puntos.
		let paths = '';
		project.perimetro.forEach((perimetro) => {
			let points = [];
			perimetro.coordenadas.forEach((coord) => {
				if (!coord.dots || coord.dots.length == 0) { points.push(coord.lat + ',' + coord.lng); }
				else { points.push(coord.dots[0].lat + ',' + coord.dots[0].lng); }
			});
			paths += "&path=" + points.join('|');
		}, this);

		// Llamar a googleapi para obtener la miníatura.
		let xhr = new XMLHttpRequest();
		// Crear la url con todos los perímetros.
		xhr.open('GET', MinisService.urlMini + paths);
		xhr.responseType = 'blob';
		// Capturar el evento de decarga.
		xhr.onload = (e) => {
			if (xhr.readyState === 4) {
				if (xhr.status === 200) {
					// Crear un elemento 'canvas' para volcar la imagen devuelta por google.
					let cnv: HTMLCanvasElement = <HTMLCanvasElement>document.createElement('canvas');
					cnv.width = 192;
					cnv.height = 120;
					let ctx = cnv.getContext('2d');
					// Necesitamos una 'img' para parsear los datos.
					let urlc = window.URL || window.webkitURL;
					let imgx: HTMLImageElement = <HTMLImageElement>document.createElement('img');
					imgx.crossOrigin = "anonymous";
					imgx.src = urlc.createObjectURL(xhr.response);
					// Esperar que la imagen haya finalizado.
					imgx.onload = () => {
						ctx.drawImage(imgx, 0, 0);
						console.log(cnv.toDataURL());
						project.mini.src = cnv.toDataURL();

						//let imgaux: HTMLImageElement = <HTMLImageElement>document.getElementById(img);
						//imgaux.crossOrigin = "anonymous";
						//imgaux.src = project.mini.src;
					}
				}
				else {
					console.error(xhr.statusText);
				}
			}
		};
		xhr.onerror = (e) => {
			console.error(xhr.statusText);
		};
		xhr.send();

		return ''; // Todo bien.
	}
}
